



















import { Component, Vue, Prop } from "vue-property-decorator";
import Avatar from "@/components/Avatar.vue";
@Component({
  components: {
    Avatar
  },
  computed: {}
})
export default class CourseItem extends Vue {
  @Prop({ required: true }) private item!: any;
  endTime() {
    // 同一天
    if (
      this.item.start_at.substring(0, 10) == this.item.end_at.substring(0, 10)
    ) {
      return this.item.end_at.substring(11, 16);
    }
    return this.item.end_at.substring(5, 16);
  }

  toCourse() {
    this.$router.push(`/course-detail?origin_id=${this.item.origin_id}`);
  }
}
